<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.61104 12.4148L13.3073 18.111L12.238 19.1648L4.73804 11.6648L12.238 4.16479L13.3073 5.21855L7.61104 10.9148H19.738V12.4148H7.61104Z" fill="currentColor"/>
</svg>
